// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

//


/* ┌─────────────────────────────────────────────────────────────────────────┐
   │  FONTE DO VÍDEO — troque aqui quando o vídeo estiver publicado             │
   │                                                                           │
   │  • YouTube: cole só o ID do vídeo (o que vem depois de "watch?v=" ou       │
   │    depois de "youtu.be/").                                                 │
   │      https://youtu.be/AbCdEfGh123   ->   VIDEO_ID = "AbCdEfGh123"          │
   │                                                                           │
   │  • Arquivo próprio (.mp4): deixe VIDEO_ID = "" e preencha VIDEO_MP4.       │
   │    Se o arquivo ficar no projeto, importe no topo, ex.:                    │
   │      import templarVideo from "assets/videos/templar.mp4";                 │
   │      e use  VIDEO_MP4 = templarVideo;                                      │
   │    Se for uma URL externa, basta colar a URL como string.                  │
   └─────────────────────────────────────────────────────────────────────────┘ */
const VIDEO_ID = "mAvQpoPZkJk"; // ex.: templarVideo (import) ou "https://..."
const VIDEO_MP4 = "";

function Video() {
  const youtubeSrc = VIDEO_ID
    ? `https://www.youtube-nocookie.com/embed/${VIDEO_ID}?rel=0&modestbranding=1`
    : "";
 
  return (
    <MKBox component="section" py={12} px={1}>
      <Container>
        <Grid container justifyContent="center" textAlign="center" sx={{ mb: 6 }}>
          <Grid item xs={12} lg={8}>
            <MKTypography variant="button" color="info" fontWeight="bold" textTransform="uppercase">
              Demonstração
            </MKTypography>
            <MKTypography variant="h3" mt={1} mb={1}>
              Veja o Templar em ação
            </MKTypography>
            <MKTypography variant="body2" color="text" fontWeight="regular">
              Uma visão rápida do MDC-SR10 V2 — do data center móvel à contenção de ataques em
              minutos.
            </MKTypography>
          </Grid>
        </Grid>
 
        {/* Moldura do vídeo — proporção 16:9 responsiva */}
        <Card sx={{ overflow: "hidden" }}>
          <MKBox sx={{ position: "relative", width: "100%", pt: "56.25%" }}>
            {youtubeSrc ? (
              <MKBox
                component="iframe"
                src={youtubeSrc}
                title="Vídeo — MDC-SR10 V2 Templar"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            ) : VIDEO_MP4 ? (
              <MKBox
                component="video"
                src={VIDEO_MP4}
                controls
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  border: 0,
                }}
              />
            ) : (
              // Placeholder exibido enquanto o vídeo não é definido
              <MKBox
                bgColor="dark"
                variant="gradient"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <MKTypography variant="h1" color="white" lineHeight={1}>
                  <Icon>play_circle</Icon>
                </MKTypography>
                <MKTypography variant="button" color="white" fontWeight="regular" mt={1}>
                  Vídeo em breve
                </MKTypography>
              </MKBox>
            )}
          </MKBox>
        </Card>
      </Container>
    </MKBox>
  );
}
 
export default Video;
